<template>
    <transition name="modal">
		<div id="ecommerce_product_edit" class="modal-mask">
			<div class="modal-wrapper" role="document">
				<div class="modal-container modal-md" style="margin-top: 35px;">
					<div class="modal-content" @click.stop>
						<div class="modal-header">
							<a href="javascript:void(0)" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
									<vue-simple-svg
                                    :filepath="'/static/img/assets/_global/Close.svg'"
                                    width="50px"
                                    height="auto"
                                    class="icon"
                                    />
								</a>
							<div class="row" style="margin-bottom: 0">
								<div class="col s12">
                                    <slot name="header"></slot>

								</div>

							</div>
							
						</div>
						<div class="modal-body">
                            <slot name="body"></slot>
						</div>

                        <div class="modal-footer">
							<slot name="footer">
								<button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">Close</button>
								<button type="button" class="btn btn-primary" @click="$emit('onSave')">Save</button>
							</slot>
						</div>
					</div>
				</div>
			</div>
		</div>
    </transition>
    
</template>

<script>
    export default {
      mounted: function () {
      var vm = this
          document.addEventListener('keydown', (e) => {
              if (e.keyCode == 27) {
                  vm.$emit('close')
                }
            })
    }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/Modal.vue